import { render, staticRenderFns } from "./HeaderTopBar.vue?vue&type=template&id=5680d4ba"
import script from "./HeaderTopBar.vue?vue&type=script&lang=js"
export * from "./HeaderTopBar.vue?vue&type=script&lang=js"
import style0 from "./HeaderTopBar.vue?vue&type=style&index=0&id=5680d4ba&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports